/* IMPORTANT: Before modifying this file, please update CHANGELOG.md with a summary of your changes.
Also, make clear comments about every change in this file and what it was replacing so that we don't end up trying the same fixes repeatedly. */

import React from 'react';

interface LoadingProps {
  isVisible: boolean;
}

const Loading: React.FC<LoadingProps> = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="flex flex-col items-center justify-center py-8">
      <div className="relative">
        <div className="h-24 w-24 rounded-full border-t-4 border-b-4 border-blue-500 animate-spin"></div>
        <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-4 border-b-4 border-transparent border-r-4 border-l-4 border-r-blue-300 border-l-blue-300 animate-ping"></div>
      </div>
      <p className="mt-4 text-lg font-medium text-gray-700">Generating your integration prompt...</p>
      <p className="text-sm text-gray-500 mt-2">This may take a few moments</p>
    </div>
  );
};

export default Loading;